// src/components/layout/BlogLayout.tsx
import React from 'react';

interface BlogLayoutProps {
  /** Content to be rendered in the top hero/header area. */
  heroContent?: React.ReactNode;
  /** The main content of the page (e.g., article grid or a single article). */
  children: React.ReactNode;
  /** Content for the sidebar, typically the BlogSidebar component. */
  sidebarContent?: React.ReactNode;
}

export const BlogLayout: React.FC<BlogLayoutProps> = ({
  heroContent,
  children,
  sidebarContent,
}) => {
  return (
    <div className="bg-slate-50 min-h-screen">
      <div className="container mx-auto px-4 py-12 md:py-16">
        {/* 1. Hero Section Slot */}
        {heroContent && (
          <header className="mb-12">
            {heroContent}
          </header>
        )}

        {/* 2. Main Content and Sidebar Wrapper */}
        <div className="flex flex-col lg:flex-row lg:gap-12">
          {/* Main Content Area */}
          <main className="flex-grow min-w-0">
            {children}
          </main>

          {/* Sidebar Area (only renders if content is provided) */}
          {sidebarContent && (
            <aside className="lg:w-80 xl:w-96 flex-shrink-0 mt-12 lg:mt-0">
              {/* The sticky container makes the sidebar follow the user on scroll on larger screens */}
              <div className="sticky top-24 space-y-8">
                {sidebarContent}
              </div>
            </aside>
          )}
        </div>
      </div>
    </div>
  );
};